function removeFooterSignup() {
  const footerSignup = document.querySelector('[gdc-js-footer-email-signup]')

  if (footerSignup) footerSignup.style.display = 'none'
}

function handleSignupCircleSection() {
  const intersectionOptions = {
    root: null, // use the viewport
    rootMargin: '0px',
    threshold: [0.3],
  }

  removeFooterSignup()

  function intersectionCallback(entries, observer) {
    entries.forEach((entry) => {
      const circle = entry.target.querySelector('.gdc-signup-circle')

      // console.log(`${Math.round(entry.intersectionRatio * 100)}%`)

      if (entry.intersectionRatio >= 0.3) {
        circle.classList.add('rise')
      } else {
        circle.classList.remove('rise')
      }
    })
  }

  const observer = new IntersectionObserver(intersectionCallback, intersectionOptions)

  const target = document.querySelector('.gdc-signup-circle-animation')
  observer.observe(target)
}

document.addEventListener('DOMContentLoaded', handleSignupCircleSection)
